<app-header [account]="account()" />

@if (account() && !layout()?.sideMenu?.hide && !isCheckout()) {
  <app-side-menu appHoverToggle />
}

<main
  id="content"
  role="main"
  class="flex-grow-1"
  [style.margin-top.px]="mainMarginTop()"
  [style.padding-left.px]="
    isXlUp() && layout()?.sideMenu?.relative ? sideMenuWidth() : 0
  "
  [class.has-footer-menu]="hasFooterMenu()"
  [class.has-side-menu]="hasSideMenu()"
  [class.is-products-page]="isProductsPage()"
  [class.is-cart-checkout-page]="isCartOrCheckoutPage()"
  [class.gpb-16]="
    !layout()?.main?.noPaddingBottom &&
    hasSideMenu() &&
    !(isProductsPage() || isCartOrCheckoutPage())
  "
  [class.bg-color]="layout()?.main?.hasBgColor"
>
  <router-outlet />
</main>

@if (hasFooterMenu()) {
  <div [class.bg-lightblue-2]="account() && !layout()?.sideMenu?.hide">
    @if (showBottomOffset()) {
      <app-bottom-offset [type]="layout()?.footer?.bottomOffset" />
    }
    <div class="gpy-24 gpy-md-0"></div>
    <app-mobile-footer [account]="account()" />
  </div>
}

@if (christmasSpirit?.isChristmas) {
  <button
    id="snowToggle"
    type="button"
    (click)="christmasSpirit.showSnowflakes = !christmasSpirit.showSnowflakes"
    [class.off]="!christmasSpirit?.showSnowflakes"
  >
    ❄️
  </button>

  @if (christmasSpirit?.showSnowflakes) {
    <app-snow />
  }
}
